export default __webpack_public_path__ + "static/HDR-how-hometown-works-icon-1v3-1809769b967a288f0b4105b3e84a5dcc.png";